import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "rhombus-react";
import {
	PREVIEW_CREATIVE_PRIVATE,
	PREVIEW_VERSION_PRIVATE,
	CREATE_MOCKUP,
	previewVersionsPrivate,
	previewCreativePrivate,
	createMockup,
	previewCreative,
	PREVIEW_CREATIVE,
	SHARE_CREATIVE,
	PREVIEW_VERSIONS,
	SHARE_VERSIONS
} from '../grid/cells/CreativeActionLists/PreviewActions';
import { isLegacyPreview } from "utils/Preview";
import { openModal } from "reducers/Modal";
import { selectedCreativeData } from "selectors/Selected";
import { MAX_SHARED_CREATIVES, MODAL_TYPES } from "utils/constants";
import { isSocialCreative, isSocialPreviewDisabled } from 'utils/common';
import{ isInvalidDVASTState, shouldDisplayAction } from 'utils/CreativeActions';

import './BulkPreviewButton.css';

export function BulkPreviewButton(){
	const dispatch = useDispatch();
	let {
		selectedItems,
		libraryId,
		user,
	} = useSelector(state=> ({
		selectedItems: selectedCreativeData(state),
		libraryId: state.libraryProperties.id,
		user: state.you,
	}));

	let previewCreativeIdsPrivate = []
		, previewVersionIdsPrivate = []
		, previewCreativeIds = []
		, shareCreativeIds = []
		, previewVersionsIds = []
		, shareVersionsIds = []
		, splitActions = []
		, divider = false;

	const pluralize = (ids) => {
		return `${ids.length > 1 ? 's' : ''}`;
	};
	const isItemsInvalidDVAST = selectedItems.every(isInvalidDVASTState);

	if(selectedItems && selectedItems.length){
		selectedItems.forEach((ea)=>{
			const isPrivatePreview = isLegacyPreview(ea);

			if(isPrivatePreview && shouldDisplayAction.privateCreativePreview(ea)){
				previewCreativeIdsPrivate.push(ea.creativeId);
			}
			if(!isPrivatePreview && shouldDisplayAction.publicCreativePreview(ea) && !isSocialPreviewDisabled(ea)){
				previewCreativeIds.push(ea.creativeId);
			}
			if(PREVIEW_VERSION_PRIVATE.shouldDisplay({ dependentValues: ea }) && !isSocialCreative(ea)){
				previewVersionIdsPrivate.push(ea.creativeId);
			}
			if(SHARE_CREATIVE.shouldDisplay({ dependentValues: ea, user })){
				shareCreativeIds.push(ea.creativeId);
			}
			if(SHARE_VERSIONS.shouldDisplay({ dependentValues: ea, user })){
				shareVersionsIds.push(ea.creativeId);
			}
			if(shouldDisplayAction.previewVersions(ea)){
				previewVersionsIds.push(ea.creativeId);
			}
		});
	}

	let previewActions = {
		previewCreativePrivate:{
			...PREVIEW_CREATIVE_PRIVATE,
			idArray:previewCreativeIdsPrivate,
			onClick:()=> previewCreativePrivate(previewCreativeIdsPrivate),
			name: `Preview Creative${pluralize(previewCreativeIdsPrivate)} (Private) (${previewCreativeIdsPrivate.length})`,
			disabled: previewCreativeIdsPrivate.length > MAX_SHARED_CREATIVES,
		 },
		previewCreative:{
			...PREVIEW_CREATIVE,
			idArray: previewCreativeIds,
			onClick:()=> previewCreative(previewCreativeIds),
			name: `Preview Creative${pluralize(previewCreativeIds)} (${previewCreativeIds.length})`,
			className: "bulk-external-link-action",
			disabled: previewCreativeIds.length > MAX_SHARED_CREATIVES,
		},
		createMockup:{
			...CREATE_MOCKUP,
			onClick:()=> createMockup(libraryId),
		},
		shareCreative:{
			...SHARE_CREATIVE,
			idArray: shareCreativeIds,
			onClick: () => dispatch(openModal(MODAL_TYPES.SHARE_CREATIVE_PREVIEWS, { creativeIds: shareCreativeIds })),
			name: `Share Creative${pluralize(shareCreativeIds)} (${shareCreativeIds.length})`,
			className: "bulk-external-link-action",
			disabled: shareCreativeIds.length > MAX_SHARED_CREATIVES,
		},
		previewVersions:{
			...PREVIEW_VERSIONS,
			idArray: previewVersionsIds,
			onClick:()=> console.log('preview versions'),
			name: `Preview Versions (${previewVersionsIds.length})`,
			className: "bulk-external-link-action",
			disabled: true,
			// disabled: previewVersionsIds.length > MAX_SHARED_CREATIVES, // Uncomment when previewVersions is eneabled
		},
		shareVersions:{
			...SHARE_VERSIONS,
			idArray: shareVersionsIds,
			onClick: () => dispatch(openModal(MODAL_TYPES.SHARE_CREATIVE_PREVIEWS, {
				creativeIds: shareVersionsIds,
				useVersionLinks: true,
			})),
			name: `Share Versions (${shareVersionsIds.length})`,
			className: "bulk-external-link-action",
			//waiting on preview features
			disabled: shareVersionsIds.length > MAX_SHARED_CREATIVES,
		},
		previewVersionPrivate:{
			...PREVIEW_VERSION_PRIVATE,
			idArray: previewVersionIdsPrivate,
			onClick:()=> previewVersionsPrivate(previewVersionIdsPrivate, PREVIEW_VERSION_PRIVATE.name),
			name: `Preview Versions (Private) (${previewVersionIdsPrivate.length})`,
			disabled: previewVersionIdsPrivate.length > MAX_SHARED_CREATIVES,
		},
	};

	if(shouldDisplayAction.createMock(user)){
		splitActions.push(previewActions.createMockup);
	}

	for(const action in previewActions) {
		const { idArray, name } = previewActions[action];

		if(idArray?.length) {
			if(name.includes('Versions') && !divider) {
				splitActions.push({ divider: true });
				// only add one divider
				divider = true;
			}
			splitActions.push(previewActions[action]);
		}
	}

	return (
		<Button
			style="block"
			icon="preview"
			theme="blue"
			isDropDown
			addClass="true"
			className="bulk-preview-button"
			splitActions={splitActions}
			disabled = {!splitActions.length || isItemsInvalidDVAST}
			splitOptions={{ footerHeight: 117000 }}
			splitValue="bulk-preview"
		>
			Previews
		</Button>
	);
}

BulkPreviewButton.displayName = "BulkPreviewButton";
